const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};

const BOLD_HOOKER_CONSTANTS = {
  swatch: {
    singleTransformSelectors: [
      '[value="Pointed Maltese with Number"]',
      '[value="Pointed Maltese with Scramble"]',
      '[value="Rounded Maltese with Number"]',
      '[value="Rounded Maltese with EMS Star of Life"]',
      '[value="Engine"]',
      '[value="Ladder"]',
      '[value="Tower"]',
      '[value="Rescue"]',
      '[value="EMS Star of Life"]',
      '[value="FD & EMS Rescue Squad"]',
      '[value="1-Color Block Letters"]',
      '[value="2-Color Block Letters"]',
      '[value="Block Letter"]',
      '[value="Beach Style"]',
      '[value="Old Style"]',
      '[value="Old English Letter"]',
      '[value="Number Shield"]',
      '[value="Gold"]'
    ],
    styles: {
      text: 'display: inline-block; padding-left: 1rem; padding-right: 1em;',
      graphic: 'transition: background-color .3s ease; outline: 3px white solid; border-radius: 0.5rem; ',
      graphicRGB: 'width: 72px; height: 35px; display: inline-block; vertical-align: text-bottom; background-size: cover;',
      graphicIMG: 'width: 150px; height: 150px; background-size: contain; background-repeat: no-repeat; margin: 0 auto; display: block;'
    }
  }
};
